import { render } from "./Clock.vue?vue&type=template&id=c310417c"
import script from "./Clock.vue?vue&type=script&lang=js"
export * from "./Clock.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Clock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c310417c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c310417c', __exports__)) {
    api.reload('c310417c', __exports__)
  }
  
  module.hot.accept("./Clock.vue?vue&type=template&id=c310417c", () => {
    api.rerender('c310417c', render)
  })

}


export default __exports__